if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.container = this.querySelector('[role="document"]');
      this.counter = this.querySelector('.lenvy-modal-nav__count');
      this.stepButtons = this.querySelectorAll('[data-lenvy-step]');
      this.stepButtons.forEach((button) => {
        button.addEventListener('click', () => this.step(Number(button.dataset.lenvyStep)));
      });
      // Tema (secondary.js) fareyle her pointerup'ta modalı kapatıyor; ok ve sayaç kapatmasın.
      this.querySelector('.lenvy-modal-nav')?.addEventListener('pointerup', (event) => event.stopPropagation());
      this.container.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.updateNav());
      }, { passive: true });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') this.step(1);
        else if (event.key === 'ArrowLeft') this.step(-1);
        else return;
        event.preventDefault();
      });
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    slides() {
      return Array.from(this.container.children).filter((el) => el.offsetParent !== null);
    }

    currentIndex() {
      const width = this.container.clientWidth || 1;
      return Math.round(this.container.scrollLeft / width);
    }

    step(direction) {
      const slides = this.slides();
      const target = slides[Math.min(Math.max(this.currentIndex() + direction, 0), slides.length - 1)];
      // Anında kaydır: mobil Chrome'da snap + smooth scrollTo dokunmatik etkileşimde yarıda kalabiliyor.
      if (!target) return;
      this.container.scrollTo({ left: target.offsetLeft, behavior: 'instant' });
      this.updateNav();
    }

    updateNav() {
      if (!this.counter) return;
      const total = this.slides().length;
      const index = Math.min(this.currentIndex(), total - 1);
      this.counter.textContent = `${index + 1} / ${total}`;
      this.stepButtons[0].disabled = index <= 0;
      this.stepButtons[1].disabled = index >= total - 1;
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      if (!activeMedia) return;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');

      this.container.scrollTo({ left: activeMedia.offsetLeft, behavior: 'instant' });
      this.updateNav();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
